import { render, staticRenderFns } from "./insurance-block.vue?vue&type=template&id=0a44492e"
import script from "./insurance-block.vue?vue&type=script&lang=js"
export * from "./insurance-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports